import type { AnyAction } from 'redux';

export type SidebarInitialState = {
  visibility: boolean;
  collapsed: boolean;
  openMenus: any[];
};

const initialState: SidebarInitialState = {
  visibility: false, // true while hovered or focused.
  collapsed: false, // true if user tagged sidebar
  openMenus: [], // id array of menus open
};

export default function reducer(state = initialState, action: AnyAction): SidebarInitialState {
  switch (action.type) {
    case 'SET_SIDEBAR_STATE':
      return {
        ...state,
        ...action.value,
      };
    case 'SET_SIDEBAR_VISIBILITY':
      return {
        ...state,
        visibility: action.value,
      };
    case 'SET_SIDEBAR_COLLAPSED':
      return {
        ...state,
        collapsed: action.value,
      };
    case 'TOGGLE_SIDEBAR_OPEN_MENUS':
      return {
        ...state,
        openMenus: state.openMenus.includes(action.value) ? [] : [action.value],
      };
    default:
      return state;
  }
}
